module.exports = __webpack_public_path__ + "static/media/schlegel_train_01.9cd7b53d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/schlegel_train_01.jpg
// module id = 386
// module chunks = 0